import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/adminAccount/AdminLogin',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/admin/AdminGetPermissionsList',
    method: 'post',
  })
}

export function logout() {
  return request({
    url: '/adminAccount/Logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js